import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import moment from 'moment'

import StudyPlanItem from '../StudyPlanItem'

import { Row, Col } from 'react-bootstrap'
import CustomProgressBar from '../../../shared/components/CustomProgressBar'

import progressBarStyle from 'Styles/progress-bar.css'
import panelStyle from 'Styles/panel.css'
import colors from 'Styles/baseColors.css'
import style from './style.css'
import baseStyle from '../../../shared/style/base.css'

import redDot from 'Assets/redDot.png'
import yellowDot from 'Assets/yellowDot.png'
import greenDot from 'Assets/greenDot.png'
import iconStyle from 'Styles/icon.css'

export default class StudentProgressBar extends Component {
  constructor (props) {
    super(props)

    this.state = {
      showDetails: false
    }
  }

  renderTopics () {
    const topicItems = this.props.topics.map(topic => {
      const hasQuestions = topic.totalQuestions > 0

      return (
        <StudyPlanItem
          itemClick={(item) => this.props.onSelectReading(topic, true, item)}
          key={topic.label}
          label={topic.label}
          totalPointsAvailable={topic.totalPointsAvailable}
          totalPointsEarned={this.props.pct ? topic.totalPointsEarned : 0}
          hasQuestions={hasQuestions}
          studyPlan={topic.studyPlan}
          disableLinks={true}
          isActive={true}
        />
      )
    })
    return (
      <div data-test-id="topicalDetails">
        <Row>
          <Col xs={12}>
            <div data-test-id="topicPerformanceDetails" style={{ marginTop: 15, marginLeft: 5 }}>
              <p className={baseStyle.pullLeft}>Topic Performance Details</p>
              <p
                style={{ marginRight: 10, fontSize: 14, color: colors.colorGrayDarker }}
                className={baseStyle.pullRight}
              >
                Accuracy
              </p>
            </div>
          </Col>
        </Row>
        <Row>
          {topicItems}
        </Row>
      </div>
    )
  }

  setDetailsState (e) {
    this.setState({ showDetails: !this.state.showDetails })
  }

  renderAccuracyBar (score) {
    return (
      <CustomProgressBar
        dataTestId="averageAccuracyBar"
        now={score}
        min={0}
        max={100}
        ariaLabel={`You have ${score} points.`}
        progressBarStyle={progressBarStyle}
        style={style}
        className={classnames(progressBarStyle.base, style.progressBar)}
        bsClass={classnames(progressBarStyle.progressValueBase, style.progressBarValue)}
      />
    )
  }

  renderGradedDot (score) {
    if (!score && score !== 0) {
      return 'in progress...'
    }

    if (score === 0) {
      return '-- %'
    }

    let gradedDot = greenDot
    if (score < 70) {
      gradedDot = redDot
    } else if (score < 90) {
      gradedDot = yellowDot
    }
    return ([
      <img
        key={score}
        src={gradedDot}
        className={classnames(iconStyle.small, style.gradedDotImg)}
        alt={'graded dot'}
        tabIndex="-1"
      />,
      `${score}%`
    ])
  }

  render () {
    return (
      <div className={classnames(panelStyle.base)} data-test-id="quizResultsPanel">
        <Row>
          <Col xs={12}>
            <div data-test-id="progressChartDesc" className={style.chartDesc}>
              {this.props.desc}
            </div>
          </Col>
        </Row>
        <Row style={{ display: 'flex', alignItems: 'center', marginBottom: 20 }}>
          <Col xs={8} sm={8} md={9} lg={9}>
            <p className={style.progressAccuracyLabel}>Accuracy:</p>
            {this.renderAccuracyBar(this.props.pct)}
          </Col>
          <Col xs={4} sm={4} md={3} lg={3} className={style.accuracyCol}>
            <p className={style.accuracyLabelScore}>Accuracy</p>
            <span
              data-test-id="quizResultsAccuracy"
              className={style.accuracyValue}
            >
              {this.renderGradedDot(this.props.pct)}
            </span>
          </Col>
        </Row>
        <Row className={style.chartContainer}>
          <Col xs={8}>
            <div>
              {this.props.pct
                ? <p
                  onClick={this.setDetailsState.bind(this)}
                  data-test-id="toggleDetailsButton"
                  style={{ fontSize: 14, color: colors.colorAquaDarker, cursor: 'pointer' }}
                >
                  {this.state.showDetails ? 'Hide details' : 'Show details'}
                </p>
                : null}
            </div>
          </Col>
        </Row>
        {
          this.props.completedTimestamp
            ? (
            <Row className={style.chartContainer}>
              <Col xs={12}>
                <div className={style.textAlignRight}>
                  <p className={style.greyLabel}>{'Target Score Reached: '}
                    {moment.utc(this.props.completedTimestamp).local().format('ddd, MMM D, h:mma')}</p>
                </div>
              </Col>
            </Row>
              )
            : null
        }
        {this.state.showDetails ? this.renderTopics() : null}
      </div>
    )
  }
}

StudentProgressBar.propTypes = {
  completedTimestamp: PropTypes.string,
  pct: PropTypes.number,
  desc: PropTypes.string,
  topics: PropTypes.array,
  retake: PropTypes.bool,
  onSelectReading: PropTypes.func
}
